// extracted by mini-css-extract-plugin
export default {"CashInMethod":"CashInMethod_CashInMethod__ObF5X","Title":"CashInMethod_Title__EjBJe","Description":"CashInMethod_Description__LT-n0"};